"use strict";

var config = require("app/util/config/config");
var cx = require("classnames");

var ListingLoader = React.createClass({
  render: function render(){
    var src = config.app.webAppURL + "/images/list-loader.gif";
    var classes = cx({
      "visible": (this.props.visible==true),
      "listingLoader": true,
      "js-listing-loader": true,
      "listingLoader--over": this.props.position == "over",
      "listingLoader--below": this.props.position == "below"
    });

    return (
      <div className={classes}>
        <img src={src}></img>
      </div>
    );
  }
});

module.exports = ListingLoader;



// WEBPACK FOOTER //
// ./app/shared/components/List/listing-loader.jsx